import { render, staticRenderFns } from "./demoForm.vue?vue&type=template&id=009538b6&scoped=true&"
import script from "./demoForm.vue?vue&type=script&lang=js&"
export * from "./demoForm.vue?vue&type=script&lang=js&"
import style0 from "./demoForm.vue?vue&type=style&index=0&id=009538b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009538b6",
  null
  
)

export default component.exports